module.exports = __webpack_public_path__ + "static/media/Round2 - img1.083f495a.jpg";